import styled from 'styled-components';

import { mediaConfined } from '@xingternal/layout-tokens';
import { xdlColorBackground } from '@xingternal/tokens';

export const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${xdlColorBackground};

  @media ${mediaConfined} {
    padding-left: 0;
    padding-right: 0;
  }
`;
